"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var connected_react_router_1 = require("connected-react-router");
var react_router_dom_1 = require("react-router-dom");
var layouts_1 = __importDefault(require("./layouts"));
var appRoutes_1 = __importDefault(require("App/util/appRoutes"));
var pages_1 = __importDefault(require("./pages"));
var _404_1 = __importDefault(require("App/pages/404"));
var AdobeWorkfrontRouter = function (_a) {
    var indexUrl = _a.indexUrl, history = _a.history, pages = _a.pages;
    var pageRoutes = appRoutes_1.default(__spreadArrays(pages, pages_1.default));
    return (react_1.default.createElement(connected_react_router_1.ConnectedRouter, { history: history },
        react_1.default.createElement(layouts_1.default, null,
            react_1.default.createElement(react_router_dom_1.Switch, null,
                react_1.default.createElement(react_router_dom_1.Route, { exact: true, path: "/", render: function () { return react_1.default.createElement(react_router_dom_1.Redirect, { to: indexUrl }); } }),
                pageRoutes,
                react_1.default.createElement(react_router_dom_1.Route, { component: _404_1.default.routeProps.component })))));
};
exports.default = AdobeWorkfrontRouter;
//# sourceMappingURL=router.js.map